<div class="container-fluid">

  <!-- Heading -->
  <div class="row pt-4 pl-4" style="font-size: 22px !important; font-weight: 400; color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Master Data</h5>
  </div>

  <div class="container">
    <div class="modal-body">

      <!-- SINGLE ROW: Cards will wrap automatically, 3 per row -->
      <div class="row g-4">

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Assignments')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="assignmentClick()">Assignments</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Tasks')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="taskClick()">Tasks</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Branch')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="branchClick()">Branch</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Financial Year')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="financialYearClick()">Financial Year</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Roles')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="rolesClick()">Roles</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Designations')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="designationClick()">Designations</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Conveyance Rates')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="conveyanceRatesClick()">Conveyance Rates</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Standard Rates')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="standardRatesClick()">Standard Rates</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Branchwise Holidays')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="branchwiseHolidayClick()">Branchwise Holidays</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Company Configuration')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="companyConfigurationClick()">Company Configuration</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Article Stipend Master')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="articleStipendMasterClick()">Article Stipend Master</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Manage Announcement')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="manageAnnouncementClick()">Manage Announcement</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Service Vertical')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:18px;"
                   (click)="serviceVerticalClick()">Service Vertical</div>
            </div>
          </div>
        </div>

      </div>
      <!-- END SINGLE ROW -->

    </div>
  </div>
</div>